<template>
<div class="container">
	<div class="columns is-centered">
		<div class="column is-5">
			<div class="title is-1 has-text-centered">
				Verify account
			</div>

			<InputBox input_type="text" v-model="token" label="Please check your email inbox or spam folder at the address you provided for verification token from esp@acmindia.org. Please enter the verification token below." icon="fas fa-check" />

			<FormErrors v-bind:errors="errors.detail" />

			<FormErrors v-bind:errors="errors.non_field_errors" />

			<button v-on:click="verify_token" class="button is-success is-fullwidth">Submit</button>
		</div>
	</div>
</div>
</template>

<script>
import InputBox from "../components/FormHelpers/InputBox";
import axios from "../api/my-axios";
import FormErrors from "../components/FormHelpers/FormErrors";
export default {
	components: {
		FormErrors,
		InputBox
	},
	data() {
		return {
			token: "",

			errors: {}
		};
	},
	methods: {
		verify_token() {
			axios
				.get(`/api/users/user/verify-email/${this.token}/`)
				.then(response => {
					this.$router.replace({ name: "LoginPage" });
					this.$store.commit("set_email_verified", true);
				})
				.catch(error => {
					this.errors = error.response ? error.response.data : {"detail": error.message};
				});
		}
	}
}
</script>
